import { TableField } from "@/types/table-field";

const id: TableField = {
  key: "Id",
  tdClass: "d-none",
  thClass: "d-none",
  sortable: false,
};
const nome: TableField = {
  key: "nomeDestinatario",
  label: "Nome",
  tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const tipo: TableField = {
  key: "tipoDestinatario",
  label: "Tipo",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const acoes: TableField = {
  key: "actions",
  label: "Ações",
  tdClass: ["align-middle", "col-actions"],
  thClass: "text-center",
  sortable: true,
};

export const fieldsDestinatarios: TableField[] = [id, nome, tipo, acoes];
export const fieldsDestinatariosDetalhes: TableField[] = [nome, tipo];
